import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { BookSectionView } from '@Selectors/publication/book/view/book-section.view';
import Repeater from '@Utils/Repeater';
import {
  ArmyOrganisationView
} from '@Selectors/builder/myArmyList/make/ArmyOrganisationView';
import { ArmyOrgSection } from './section-army-org.component.styled';

interface SectionRowComponentProps {
  section: BookSectionView;
}

const SectionArmyOrgCommponent: React.FC<Props> = ({ organisationGroups }) => {
  if (organisationGroups.length === 0)
    return (<></>);

  return (
    <ArmyOrgSection className="row justify-content-center">
      <Repeater data={organisationGroups} indexPrefix="organisation">
        {
          (item: ArmyOrganisationView) => (
            <div className="col-4 col-md-2 p-0 text-center text-small">
              {item.logo && <img alt={item.name} src={item.logo} className="img-fluid" />}
              <p>{item.name}</p>
              <div>
                <p className={'rate'}>
                  <small>{item.rate}</small>
                </p>
              </div>
            </div>
          )
        }
      </Repeater>
    </ArmyOrgSection>
  );
};

const mapStateToProps = (state: AppState, _: SectionRowComponentProps) => ({
  organisationGroups: []
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SectionArmyOrgCommponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  SectionRowComponentProps
